import axios from "./axiosInstance";

// export const baseUrl = 'http://localhost:8080/';
export const baseUrl = process.env.REACT_APP_URL;

let lang = JSON.parse(localStorage.getItem("lang"));

export default async function loginRequest(email, password) {
  let form = new FormData();
  form.append("email", email);
  form.append("password", password);

  var reponse = null;
  await axios
    .post(baseUrl + "signin", form)
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}
//Theme
export async function listTheme() {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "themes", { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertTheme(description) {
  let form = new FormData();
  form.append("description", description);
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "themes", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyTheme(description, idtheme) {
  let form = new FormData();
  form.append("description", description);

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "themes/" + idtheme, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOneTheme(idtheme) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "themes/" + idtheme, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function deleteTheme(idTheme) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "themes/" + idTheme, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}
// Communique de presse
export async function listCommunique(
  page = 1,
  limit = 10,
  date = null,
  theme = null,
  titre = "",
) {
  // Traitement filtre
  var fullUrl = baseUrl + "communiques?page=" + page;
  if (date !== "") {
    fullUrl += "&datepublication=" + date;
  }
  if (theme !== "") {
    fullUrl += "&theme=" + theme;
  }
  if (titre !== "") {
    fullUrl += "&titre=" + titre;
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertCommunique(titre, date, theme, media, texte) {
  let form = new FormData();
  form.append("theme", theme);
  form.append("titre", titre);
  form.append("datepublication", date);
  form.append("texte", texte);
  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("media-file", media[i]);
    }
  } else {
    form.append("media-file", media);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "communiques/1", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function deleteCommunique(idCommunique) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "communiques/" + idCommunique, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOneComunnique(idCommunique) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "communiques/" + idCommunique, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyCommunique(
  idcommunique,
  titre,
  date,
  theme,
  media,
  background,
  document,
  texte,
  acteur,
  ville,
  langage,
  keys = [],
  isArticle = false,
  isPresse = false,
  une = "1",
  source = "",
  lien = "",
) {
  let form = new FormData();
  form.append("theme", theme);
  form.append("titre", titre);
  form.append("datepublication", date);
  form.append("texte", texte);
  if (une !== null && une !== "") {
    form.append("une", une);
  }
  if (isArticle === true) {
    form.append("isarticle", 1);
  } else {
    form.append("isarticle", 0);
  }
  if (isPresse === true) {
    form.append("ispresse", 1);
  } else {
    form.append("ispresse", 0);
  }

  form.append("acteur", acteur);
  form.append("ville", ville);
  form.append("language", langage);
  form.append("source", source || "");
  form.append("lien", lien || "");

  //Ajout des mots clés
  for (var i = 0; i < keys.length; i++) {
    form.append("keywords", keys[i].idkeyword);
  }

  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("media-file", media[i]);
    }
  } else {
    form.append("media-file", media);
  }

  //Ajout background
  if (background !== null) {
    for (let i = 0; i < background.length; i++) {
      form.append("background-file", background[i]);
    }
  } else {
    form.append("background-file", background);
  }

  //Ajout document
  if (document !== null) {
    for (let i = 0; i < document.length; i++) {
      form.append("document-file", document[i]);
    }
  } else {
    form.append("document-file", document);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "communiques/" + idcommunique, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Podcast
export async function listPodcast(
  page = 1,
  limit = 10,
  date = null,
  titre = "",
  categorie = "all",
) {
  // Onglets liste podcast : réutilise les endpoints existants par catégorie (genre 12 / != 12).
  var path = "podcasts/all";
  if (categorie === "ca") path = "podcasts";
  else if (categorie === "others") path = "podcasts/others";
  var fullUrl = baseUrl + path + "?page=" + page + "&limit=" + limit;
  if (categorie === "all") {
    if (date !== null && date !== "") {
      fullUrl += "&datepublication=" + date;
    }
    if (titre !== "") {
      fullUrl += "&titre=" + titre;
    }
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertPodcast(
  titre,
  date,
  media,
  lien,
  textetranscription,
  idcategoriemedia,
) {
  let form = new FormData();
  form.append("titre", titre);
  form.append("datepublication", date);
  form.append("lien", lien);
  if (textetranscription !== null && textetranscription !== "")
    form.append("alt", textetranscription);

  if (idcategoriemedia !== null && idcategoriemedia !== "") {
    form.append("genremedia", idcategoriemedia);
  }

  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("transcription", media[i]);
    }
  } else {
    form.append("transcription", media);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "podcasts", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function deletePodcast(idPodcast) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "podcasts/" + idPodcast, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOnePodcast(idPodcast) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "podcasts/" + idPodcast, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function verifyPodcast(idPodcast) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "podcasts/" + idPodcast + "/verify", {}, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function sendPodcast(idPodcast) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "podcasts/" + idPodcast + "/send", {}, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Aperçu paginé des abonnés qui recevront le podcast (comme la confirmation d'envoi des communiqués).
export async function getPodcastSubscribers(page = 0, size = 8, search = "") {
  var url = baseUrl + "podcasts/subscribers?page=" + page + "&size=" + size;
  if (search) url += "&search=" + encodeURIComponent(search);
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(url, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyPodcast(
  idPodcast,
  titre,
  date,
  media,
  lien,
  textetranscription,
  idcategoriemedia,
) {
  let form = new FormData();
  form.append("titre", titre);
  form.append("datepublication", date);
  form.append("lien", lien);
  form.append("alt", textetranscription);
  if (idcategoriemedia !== null && idcategoriemedia !== "") {
    form.append("genremedia", idcategoriemedia);
  }
  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("transcription", media[i]);
    }
  } else {
    form.append("transcription", media);
  }
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "podcasts/" + idPodcast, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Evenement
export async function listEvenement(
  page = 1,
  limit = 10,
  datedebut = null,
  datefin = null,
  titre = "",
  theme = "",
  filtre = 0,
) {
  var fullUrl = baseUrl + "evenements?page=" + page;
  if (datedebut !== "" && datedebut !== null) {
    fullUrl += "&datedebut=" + datedebut;
  }
  if (datefin !== "") {
    fullUrl += "&datefin=" + datefin;
  }
  if (titre !== "") {
    fullUrl += "&titre=" + titre;
  }

  // if (lang !== null && lang !== undefined) {
  //     fullUrl += '&lang=' + lang.idlanguage;
  // }

  if (theme !== null && theme !== "") {
    fullUrl += "&theme=" + theme;
  }

  fullUrl += "&filtre=" + filtre;

  // alert(fullUrl)

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listAllEvenement(
  page = 1,
  limit = 10,
  datedebut = null,
  datefin = null,
  titre = "",
) {
  var fullUrl = baseUrl + "allevenements?page=" + page;
  if (datedebut !== "" && datedebut !== null) {
    fullUrl += "&datedebut=" + datedebut;
  }
  if (datefin !== "") {
    fullUrl += "&datefin=" + datefin;
  }
  if (titre !== "") {
    fullUrl += "&titre=" + titre;
  }

  // if (lang !== null && lang !== undefined) {
  //     fullUrl += '&lang=' + lang.idlanguage;
  // }

  // alert(fullUrl)

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertEvenement(
  titre,
  date,
  media,
  texte,
  datefin,
  language,
  lien,
  ville,
  theme = null,
) {
  let form = new FormData();
  form.append("titre", titre);
  form.append("datepublication", date);
  form.append("texte", texte);
  form.append("datefin", datefin);
  form.append("language", language);
  form.append("theme", theme);
  form.append("lien", lien);
  form.append("ville", ville);
  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("media-file", media[i]);
    }
  } else {
    form.append("media-file", media);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "evenements", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function deleteEvenement(idPodcast) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "evenements/" + idPodcast, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOneEvenement(idPodcast) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "evenements/" + idPodcast, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyEvenement(
  idPodcast,
  titre,
  date,
  media,
  texte,
  datefin,
  langage,
  lien,
  ville,
  theme,
) {
  let form = new FormData();
  form.append("titre", titre);
  form.append("datepublication", date);
  form.append("texte", texte);
  form.append("datefin", datefin);
  form.append("language", langage);
  form.append("theme", theme);
  form.append("lien", lien);
  form.append("ville", ville);
  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("media-file", media[i]);
    }
  }
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "evenements/" + idPodcast, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Media
export async function listMedia(page = 1, limit = 10, titre = "", type = null) {
  var fullUrl = baseUrl + "medias?page=" + page;
  if (titre !== "") {
    fullUrl += "&titre=" + titre;
  }

  if (type !== "") {
    fullUrl += "&type=" + type;
  }

  fullUrl += "&limit=" + limit;

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listPhoto(
  page = 1,
  limit = 10,
  titre = null,
  datepublication = null,
  categorie = null,
  tri = null,
) {
  var fullUrl = baseUrl + "photos?page=" + page;

  fullUrl += "&limit=" + limit;
  if (titre !== null && titre !== "")
    fullUrl += "&titre=" + encodeURIComponent(titre);
  if (datepublication !== null && datepublication !== "")
    fullUrl += "&datepublication=" + datepublication;
  if (categorie !== null && categorie !== "")
    fullUrl += "&categorie=" + categorie;
  if (tri !== null && tri !== "") fullUrl += "&tri=" + tri;

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listVideo(
  page = 1,
  limit = 10,
  titre = null,
  datepublication = null,
  categorie = null,
  theme = null,
  type = null,
  tri = null,
) {
  var fullUrl = baseUrl + "videos?page=" + page;

  fullUrl += "&limit=" + limit;
  if (titre !== null && titre !== "")
    fullUrl += "&titre=" + encodeURIComponent(titre);
  if (datepublication !== null && datepublication !== "")
    fullUrl += "&datepublication=" + datepublication;
  if (categorie !== null && categorie !== "")
    fullUrl += "&categorie=" + categorie;
  if (theme !== null && theme !== "") fullUrl += "&theme=" + theme;
  if (type !== null && type !== "") fullUrl += "&type=" + type;
  if (tri !== null && tri !== "") fullUrl += "&tri=" + tri;

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listDoc(
  page = 1,
  limit = 10,
  titre = null,
  datepublication = null,
  categorie = null,
  entite = null,
  lang = null,
  hasLang = null,
) {
  var fullUrl = baseUrl + "docs?page=" + page;

  fullUrl += "&limit=" + limit;
  if (titre !== null && titre !== "")
    fullUrl += "&titre=" + encodeURIComponent(titre);
  if (datepublication !== null && datepublication !== "")
    fullUrl += "&datepublication=" + datepublication;
  if (categorie !== null && categorie !== "")
    fullUrl += "&categorie=" + categorie;
  if (entite !== null && entite !== "") fullUrl += "&entite=" + entite;
  if (lang !== null && lang !== "") fullUrl += "&lang=" + lang;
  if (hasLang !== null && hasLang !== "") fullUrl += "&hasLang=" + hasLang;

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function deleteMedia(idMedia) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "medias/" + idMedia, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertMedia(titre, media, alt) {
  let form = new FormData();
  form.append("titre", titre);
  if (alt !== null && alt !== undefined) {
    form.append("alt", alt);
  }

  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("lien-file", media[i]);
    }
  } else {
    form.append("lien-file", media);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "medias", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertPhoto(
  titre,
  media,
  alt,
  visibilite = "0",
  idgenremedia = null,
  idlanguage,
  date,
) {
  let form = new FormData();
  form.append("titre", titre);
  form.append("ispublique", visibilite);
  form.append("language", idlanguage);
  form.append("datepublication", date);
  if ((idgenremedia !== null, idgenremedia !== "")) {
    form.append("genremedia", idgenremedia);
  }
  if (alt !== null && alt !== undefined) {
    form.append("alt", alt);
  }

  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("lien-file", media[i]);
    }
  } else {
    form.append("lien-file", media);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "photos", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertVideo(titre, media, alt) {
  let form = new FormData();
  form.append("titre", titre);
  if (alt !== null && alt !== undefined) {
    form.append("alt", alt);
  }

  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("lien-file", media[i]);
    }
  } else {
    form.append("lien-file", media);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "videos", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function lastInsertVideo(
  titre,
  lien,
  media,
  theme,
  date,
  visibilite = "0",
  idgenremedia = null,
  language,
) {
  let form = new FormData();
  form.append("titre", titre);
  form.append("theme", theme);
  form.append("datepublication", date);
  form.append("ispublique", visibilite);
  form.append("language", language);
  if ((idgenremedia !== null, idgenremedia !== "")) {
    form.append("genremedia", idgenremedia);
  }

  if (lien !== null && lien !== undefined) {
    form.append("lien", lien);
  }

  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("illusatration-image", media[i]);
    }
  } else {
    form.append("illusatration-image", media);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "videos", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function directInsertVideo(
  titre,
  media,
  image,
  theme,
  date,
  visibilite = "0",
  idgenremedia = null,
  idlanguage,
) {
  let form = new FormData();
  form.append("titre", titre);
  form.append("theme", theme);
  form.append("datepublication", date);
  form.append("ispublique", visibilite);
  form.append("language", idlanguage);
  if ((idgenremedia !== null, idgenremedia !== "")) {
    form.append("genremedia", idgenremedia);
  }

  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("video", media[i]);
    }
  } else {
    form.append("video", media);
  }

  if (image !== null) {
    for (let i = 0; i < image.length; i++) {
      form.append("illusatration-image", image[i]);
    }
  } else {
    form.append("illusatration-image", image);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "direct-videos", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}
export async function insertDocument(
  titre,
  media,
  alt,
  photo,
  visibilite = "0",
  idgenremedia = null,
  identite = null,
  language,
  date,
) {
  let form = new FormData();
  form.append("titre", titre);
  form.append("ispublique", visibilite);
  form.append("language", language);
  form.append("datepublication", date);
  // alert(language);
  if (identite !== null && identite !== null) {
    form.append("entite", identite);
  }
  if (idgenremedia !== null && idgenremedia !== "") {
    form.append("genremedia", idgenremedia);
  }
  if (alt !== null && alt !== undefined) {
    form.append("alt", alt);
  }

  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("lien-file", media[i]);
    }
  } else {
    form.append("lien-file", media);
  }

  if (photo !== null) {
    for (let i = 0; i < photo.length; i++) {
      form.append("photo-document", photo[i]);
    }
  } else {
    form.append("photo-document", photo);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "docs", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyMedia(
  idMedia,
  titre,
  media = null,
  alt = null,
  date = null,
  theme = null,
  visibilite = "0",
  idgenremedia = null,
  identite = null,
  language,
  illustration = null,
) {
  let form = new FormData();
  form.append("titre", titre);
  if (language !== null && language !== undefined) {
    form.append("language", language);
  }
  if (identite !== null && identite !== "") {
    form.append("entite", identite);
  }
  if (idgenremedia !== null && idgenremedia !== "") {
    form.append("genremedia", idgenremedia);
  }
  if (date !== null && date !== undefined) {
    form.append("datepublication", date);
  }
  // form.append('datepublication', date);
  if (theme !== null && theme !== undefined) {
    form.append("theme", theme);
  }

  form.append("ispublique", visibilite);
  if (alt !== null && alt !== undefined) {
    form.append("alt", alt);
  }
  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("lien-file", media[i]);
    }
  }
  if (illustration !== null) {
    for (let i = 0; i < illustration.length; i++) {
      form.append("illusatration-image", illustration[i]);
    }
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "medias/" + idMedia, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOneMedia(idMedia) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "medias/" + idMedia, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Utilisateur
export async function listUtilisateur(
  page = 1,
  limit = 10,
  groupe = null,
  role = null,
) {
  var fullUrl = baseUrl + "utilisateurs?page=" + page;
  if (groupe !== "") {
    fullUrl += "&groupe=" + groupe;
  }

  if (role !== "") {
    fullUrl += "&role=" + role;
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function deleteUtilisateur(idUtilisateur) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "utilisateurs/" + idUtilisateur, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertUtilisateur(
  nom,
  prenom,
  poste,
  email,
  password,
  role,
  permission,
) {
  let form = new FormData();
  form.append("nom", nom);
  form.append("prenom", prenom);
  form.append("poste", poste);
  form.append("email", email);
  form.append("password", password);
  form.append("role", role);
  form.append("permission", permission);

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "signup", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOneUtilisateur(idUtilisateur) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "utilisateurs/" + idUtilisateur, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyUtilisateur(
  idutilisateur,
  nom,
  prenom,
  poste,
  email,
  role,
  permission,
) {
  let form = new FormData();
  form.append("nom", nom);
  form.append("prenom", prenom);
  form.append("poste", poste);
  form.append("email", email);
  form.append("role", role);
  form.append("permission", permission);

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "utilisateurs/" + idutilisateur, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function resetPasswordUtilisateur(
  idUtilisateur,
  nouveauMotDePasse,
) {
  let form = new FormData();
  form.append("nouveauMotDePasse", nouveauMotDePasse);

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "utilisateurs/" + idUtilisateur + "/reset-password", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function renvoyerEmailActivation(idUtilisateur) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "utilisateurs/" + idUtilisateur + "/email-activation", null, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyMonProfil(idutilisateur, nom, prenom, poste, role) {
    let form = new FormData();
    form.append('nom', nom);
    form.append('prenom', prenom);
    form.append('poste', poste);
    form.append('role', role);

    var reponse = null;
    const token = localStorage.getItem('token');
    await axios.put(baseUrl + 'utilisateurs/' + idutilisateur + '/mon-profil', form, {
        headers: { Authorization: "Bearer " + token }
    })
        .then(function (response) { reponse = response; })
        .catch(function (error) { reponse = error.response; })
    return reponse;
}

export async function verifyPassword(idutilisateur, motDePasseActuel) {
    let form = new FormData();
    form.append('motDePasseActuel', motDePasseActuel);

    var reponse = null;
    const token = localStorage.getItem('token');
    await axios.post(baseUrl + 'utilisateurs/' + idutilisateur + '/verify-password', form, {
        headers: { Authorization: "Bearer " + token }
    })
        .then(function (response) { reponse = response; })
        .catch(function (error) { reponse = error.response; })
    return reponse;
}

export async function adminCheckPassword(idutilisateur, motDePasse) {
    let form = new FormData();
    form.append('motDePasse', motDePasse);

    var reponse = null;
    const token = localStorage.getItem('token');
    await axios.post(baseUrl + 'utilisateurs/' + idutilisateur + '/check-password', form, {
        headers: { Authorization: "Bearer " + token }
    })
        .then(function (response) { reponse = response; })
        .catch(function (error) { reponse = error.response; })
    return reponse;
}

export async function changePassword(idutilisateur, motDePasseActuel, nouveauMotDePasse) {
    let form = new FormData();
    form.append('motDePasseActuel', motDePasseActuel);
    form.append('nouveauMotDePasse', nouveauMotDePasse);

    var reponse = null;
    const token = localStorage.getItem('token');
    await axios.put(baseUrl + 'utilisateurs/' + idutilisateur + '/change-password', form, {
        headers: { Authorization: "Bearer " + token }
    })
        .then(function (response) { reponse = response; })
        .catch(function (error) { reponse = error.response; })
    return reponse;
}

// Roles et permissions
export async function listRole() {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "roles", { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listPermission() {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "permissions", {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Protection pages
export function isEditor() {
  const permission = JSON.parse(localStorage.getItem("user")).perm.description;
  if (permission === "EDITOR") {
    return true;
  }
  return false;
}

export function isAxianGroup() {
  const role = JSON.parse(localStorage.getItem("user")).role.description;
  if (role === "AXIAN_GROUP") {
    return true;
  }
  return false;
}

export function isAxianTelecom() {
  const role = JSON.parse(localStorage.getItem("user")).role.description;
  if (role === "AXIAN_TELECOM") {
    return true;
  }
  return false;
}

export function isAdministrateur() {
  const permission = JSON.parse(localStorage.getItem("user")).perm.description;
  if (permission === "ADMIN") {
    return true;
  }
  return false;
}

export function isEnableModify() {
  if (isEditor() || isAdministrateur()) {
    return true;
  }
  return false;
}

export function isActif() {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user === undefined || user === null) {
    return false;
  }
  return true;
}

// Types media
export async function listTypeMedia() {
  var fullUrl = baseUrl + "types";
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Abonnee
export async function exportAbonnees(
  format,
  typeActualite = "",
  theme = "",
  langue = "",
  localisation = "",
) {
  const token = localStorage.getItem("token");
  let url = baseUrl + "abonnees/export?format=" + format;
  if (typeActualite) url += "&typeActualite=" + typeActualite;
  if (theme) url += "&theme=" + theme;
  if (langue) url += "&langue=" + langue;
  if (localisation) url += "&localisation=" + encodeURIComponent(localisation);

  var reponse = null;
  await axios
    .get(url, {
      headers: { Authorization: "Bearer " + token },
      responseType: "blob",
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function exportAbonneesStats(format) {
  const token = localStorage.getItem("token");
  var reponse = null;
  await axios
    .get(baseUrl + "abonnees/export/stats?format=" + format, {
      headers: { Authorization: "Bearer " + token },
      responseType: "blob",
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getAbonneesFiltred(typeActualite = "") {
  let url = baseUrl + "abonnees/filtred";
  if (typeActualite) url += "?typeActualite=" + typeActualite;
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(url, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function listTypeActualite() {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "typeactualites", { headers: { Authorization: "Bearer " + token } })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function listAbonnee(page = 1, limit = 10, nom = "", email = "") {
  var fullUrl = baseUrl + "abonnees?page=" + page;
  if (nom !== "") {
    fullUrl += "&nom=" + nom;
  }

  if (email !== "") {
    fullUrl += "&email=" + email;
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function deleteAbonnee(idAbonnee) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "abonnees/" + idAbonnee, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function abonnementPerso(
  nom,
  prenom,
  email,
  job,
  localisation,
  telephone,
  societe,
  website,
  actualite,
  podcast,
  evenement,
) {
  let form = new FormData();
  if (job !== null && job !== "") {
    form.append("job", job);
  }
  if (localisation !== null && localisation !== "") {
    form.append("localisation", localisation);
  }
  if (telephone !== null && telephone !== "") {
    form.append("telephone", telephone);
  }
  if (societe !== null && societe !== "") {
    form.append("societe", societe);
  }
  if (website !== null && website !== "") {
    form.append("website", website);
  }
  if (nom !== null && nom !== "") {
    form.append("nom", nom);
  }
  if (prenom !== null && prenom !== "") {
    form.append("prenom", prenom);
  }
  if (email !== null && email !== "") {
    form.append("email", email);
  }
  if (actualite !== null && actualite !== "") {
    form.append("actualite", actualite);
  }
  if (podcast !== null && podcast !== "") {
    form.append("podcast", podcast);
  }
  if (evenement !== null && evenement !== "") {
    form.append("evenement", evenement);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "abonnement", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOneAbonnement(idAbonnee) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "abonnees/" + idAbonnee, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getAbonnementAbonnee(idAbonnee) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "abonnement/" + idAbonnee, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modificationAbonnementPerso(
  nom,
  prenom,
  email,
  job,
  localisation,
  telephone,
  societe,
  website,
  actualite,
  podcast,
  evenement,
  id,
) {
  let form = new FormData();
  if (job !== null && job !== "") {
    form.append("job", job);
  }
  if (localisation !== null && localisation !== "") {
    form.append("localisation", localisation);
  }
  if (telephone !== null && telephone !== "") {
    form.append("telephone", telephone);
  }
  if (societe !== null && societe !== "") {
    form.append("societe", societe);
  }
  if (website !== null && website !== "") {
    form.append("website", website);
  }
  if (nom !== null && nom !== "") {
    form.append("nom", nom);
  }
  if (prenom !== null && prenom !== "") {
    form.append("prenom", prenom);
  }
  if (email !== null && email !== "") {
    form.append("email", email);
  }
  if (actualite !== null && actualite !== "") {
    form.append("actualite", actualite);
  }
  if (podcast !== null && podcast !== "") {
    form.append("podcast", podcast);
  }
  if (evenement !== null && evenement !== "") {
    form.append("evenement", evenement);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "abonnement/" + id, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}
// Import
export async function importAbonnee(oneFile) {
  let form = new FormData();
  form.append("csvabonnee", oneFile);
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "abonnee-import", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function importUtilisateur(oneFile) {
  let form = new FormData();
  form.append("csvuser", oneFile);
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "utilisateur-import", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function importExcelUtilisateur(oneFile) {
  let form = new FormData();
  form.append("exceluser", oneFile);
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "excelToUtilisateur", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function importExcelAbonee(oneFile) {
  let form = new FormData();
  form.append("excelabonnee", oneFile);
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "excelToAbonnee", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function abonnement(
  nom,
  prenom,
  email,
  job,
  localisation,
  telephone,
  societe,
  website,
) {
  let form = new FormData();
  if (job !== null && job !== "") {
    form.append("job", job);
  }
  if (localisation !== null && localisation !== "") {
    form.append("localisation", localisation);
  }
  if (telephone !== null && telephone !== "") {
    form.append("telephone", telephone);
  }
  if (societe !== null && societe !== "") {
    form.append("societe", societe);
  }
  if (website !== null && website !== "") {
    form.append("website", website);
  }
  if (nom !== null && nom !== "") {
    form.append("nom", nom);
  }
  if (prenom !== null && prenom !== "") {
    form.append("prenom", prenom);
  }
  if (email !== null && email !== "") {
    form.append("email", email);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "abonnement", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function Nouvelabonnement(
  nom,
  prenom,
  email,
  job,
  localisation,
  telephone,
  societe,
  website,
  isMail = "1",
  isWhatsapp = "1",
) {
  let form = new FormData();
  if (job !== null && job !== "") {
    form.append("job", job);
  }
  if (localisation !== null && localisation !== "") {
    form.append("localisation", localisation);
  }
  if (telephone !== null && telephone !== "") {
    form.append("telephone", telephone);
  }
  if (societe !== null && societe !== "") {
    form.append("societe", societe);
  }
  if (website !== null && website !== "") {
    form.append("website", website);
  }
  if (nom !== null && nom !== "") {
    form.append("nom", nom);
  }
  if (prenom !== null && prenom !== "") {
    form.append("prenom", prenom);
  }
  if (email !== null && email !== "") {
    form.append("email", email);
  }
  if (isMail !== null && isMail !== "") {
    form.append("mail", isMail);
  }
  if (isWhatsapp !== null && isWhatsapp !== "") {
    form.append("whatsapp", isWhatsapp);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "abonnement", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modificationAbonnement(
  nom,
  prenom,
  email,
  job,
  localisation,
  telephone,
  societe,
  website,
  isMail = "1",
  isWhatsapp = "1",
  id,
) {
  let form = new FormData();
  if (job !== null && job !== "") {
    form.append("job", job);
  }
  if (localisation !== null && localisation !== "") {
    form.append("localisation", localisation);
  }
  if (telephone !== null && telephone !== "") {
    form.append("telephone", telephone);
  }
  if (societe !== null && societe !== "") {
    form.append("societe", societe);
  }
  if (website !== null && website !== "") {
    form.append("website", website);
  }
  if (nom !== null && nom !== "") {
    form.append("nom", nom);
  }
  if (prenom !== null && prenom !== "") {
    form.append("prenom", prenom);
  }
  if (email !== null && email !== "") {
    form.append("email", email);
  }
  if (isMail !== null && isMail !== "") {
    form.append("mail", isMail);
  }
  if (isWhatsapp !== null && isWhatsapp !== "") {
    form.append("whatsapp", isWhatsapp);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "abonnement/" + id, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertCommuniqueChoice(
  titre,
  date,
  theme,
  media,
  background,
  document,
  texte,
  acteur,
  ville,
  langage,
  keys = [],
  com = null,
  article = null,
  presse = null,
  lien,
  source,
  une = "1",
) {
  let form = new FormData();
  form.append("theme", theme);
  form.append("titre", titre);
  form.append("datepublication", date);
  form.append("texte", texte);
  form.append("acteur", acteur);
  form.append("ville", ville);
  form.append("language", langage);
  form.append("lien", lien);
  if (source !== null && source !== "") {
    form.append("mediaSource", source);
  }
  if (une !== null && une !== "") {
    form.append("une", une);
  }

  for (var i = 0; i < keys.length; i++) {
    form.append("keywords", keys[i].idkeyword);
  }

  if (com !== null && com !== "") {
    form.append("communique", com);
  }

  if (article !== null && article !== "") {
    form.append("article", article);
  }

  if (presse !== null && presse !== "") {
    form.append("presse", presse);
  }
  //Ajout media
  if (media !== null) {
    for (let i = 0; i < media.length; i++) {
      form.append("media-file", media[i]);
    }
  } else {
    form.append("media-file", media);
  }

  //Ajout background
  if (background !== null) {
    for (let i = 0; i < background.length; i++) {
      form.append("background-file", background[i]);
    }
  } else {
    form.append("background-file", background);
  }

  //Ajout document
  if (document !== null) {
    for (let i = 0; i < document.length; i++) {
      form.append("document-file", document[i]);
    }
  } else {
    form.append("document-file", document);
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "communiques", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listCommuniqueChoice(
  page = 1,
  limit = 10,
  date = null,
  theme = null,
  titre = "",
  com = "1",
  article = "1",
  presse = "1",
  language = null,
  isGroupe = false,
) {
  // Traitement filtre
  var fullUrl = baseUrl + "communiques?page=" + page;
  // Le backend pagine alors par sujet (une actualité + sa traduction) et renvoie data = liste de sujets.
  if (isGroupe) {
    fullUrl += "&grouper=1";
  }
  if (date !== "") {
    fullUrl += "&datepublication=" + date;
  }

  if (theme !== "") {
    fullUrl += "&theme=" + theme;
  }

  if (titre !== "") {
    fullUrl += "&titre=" + titre;
  }

  if (com !== null && com !== "") {
    fullUrl += "&com=" + com;
  }

  if (article !== null && article !== "") {
    fullUrl += "&article=" + article;
  }

  if (presse !== null && presse !== "") {
    fullUrl += "&presse=" + presse;
  }

  if (language !== null && language !== "") {
    fullUrl += "&lang=" + language;
  }

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

//Recherche global
export async function rechercheGlobalActualite(
  page = 1,
  limit = 10,
  critere = "",
  langage,
) {
  var fullUrl = baseUrl + "recherche-actualite?page=" + page;
  fullUrl += "&critere=" + critere;
  if (lang !== null && lang !== undefined) {
    fullUrl += "&lang=" + lang.idlanguage;
  }

  var reponse = null;
  const token = localStorage.getItem("token");

  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function rechercheGlobalEvenement(
  page = 1,
  limit = 10,
  critere = "",
) {
  var fullUrl = baseUrl + "recherche-evenement?page=" + page;
  fullUrl += "&critere=" + critere;
  if (lang !== null && lang !== undefined) {
    fullUrl += "&lang=" + lang.idlanguage;
  }

  var reponse = null;
  const token = localStorage.getItem("token");

  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function rechercheGlobalUtilisateur(
  page = 1,
  limit = 10,
  critere = "",
) {
  var fullUrl = baseUrl + "recherche-utilisateur?page=" + page;
  fullUrl += "&critere=" + critere;

  var reponse = null;
  const token = localStorage.getItem("token");

  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function rechercheGlobalAbonnee(
  page = 1,
  limit = 10,
  critere = "",
) {
  var fullUrl = baseUrl + "recherche-abonnee?page=" + page;
  fullUrl += "&critere=" + critere;

  var reponse = null;
  const token = localStorage.getItem("token");

  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function rechercheGlobalTheme(critere = "") {
  var fullUrl = baseUrl + "recherche-theme?critere=" + critere;

  var reponse = null;
  const token = localStorage.getItem("token");

  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

//Historiques
export async function listHistoriques() {
  var fullUrl = baseUrl + "historiques";
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Rapport Abonnée
export async function getAllAutomatisations(params = {}) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "rapport-abonnee/config", {
      headers: { Authorization: "Bearer " + token },
      params,
    })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function createAutomatisation(data) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "rapport-abonnee/config", data, {
      headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
    })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function updateAutomatisation(id, data) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "rapport-abonnee/config/" + id, data, {
      headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
    })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function deleteAutomatisation(id) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "rapport-abonnee/config/" + id, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function envoyerAutomatisationMaintenant(id) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "rapport-abonnee/config/" + id + "/envoyer-maintenant", null, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function getRapportAbonneeRecurrences() {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "rapport-abonnee/recurrences", {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function createRecurrence(data) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "rapport-abonnee/recurrences", data, {
      headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
    })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function updateRecurrence(id, data) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "rapport-abonnee/recurrences/" + id, data, {
      headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
    })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function deleteRecurrence(id) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "rapport-abonnee/recurrences/" + id, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) { reponse = response; })
    .catch(function (error) { reponse = error.response; });
  return reponse;
}

export async function listHistoriquesPagination(page = 1, limit = 10) {
  var fullUrl = baseUrl + "historiques?page=" + page;
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listHistoriqueTelecomPagination(page = 1, limit = 10) {
  var fullUrl = baseUrl + "historiques-telecom?page=" + page;
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function annulerHistoriques(idhistorique) {
  var fullUrl = baseUrl + "historiques/" + idhistorique;
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listLanguage() {
  var fullUrl = baseUrl + "languages";
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

//Keywords
export async function listKeywords() {
  var fullUrl = baseUrl + "keywords";
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function createKeywords(description) {
  let form = new FormData();
  form.append("description", description);
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "keywords", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// recherche full text

export async function rechercheFullTextActualite(
  page = 1,
  limit = 10,
  critere = "",
  langage,
) {
  var fullUrl = baseUrl + "recherche-fulltext?page=" + page;
  fullUrl += "&critere=" + critere;
  if (lang !== null && lang !== undefined) {
    fullUrl += "&lang=" + lang.idlanguage;
  }

  var reponse = null;
  const token = localStorage.getItem("token");

  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export function nFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}

export function formattingWithoutYear(date) {
  date = date.substring(0, 4) + "-" + date.substring(4, date.length);
  date = date.substring(0, 7) + "-" + date.substring(7, date.length);
  const d = new Date(date);
  var options = { month: "short", day: "numeric" };
  return d.toLocaleDateString([], options);
}

// Porte parole
export async function insertContact(
  nom,
  prenom,
  fonction,
  contact,
  biographie,
  photo,
  typecontact,
  biographieen,
  linkedin,
  rang,
) {
  let form = new FormData();
  form.append("nom", nom);
  form.append("prenom", prenom);
  form.append("fonction", fonction);
  form.append("info", contact);
  form.append("biographie", biographie);
  form.append("typecontact", typecontact);
  form.append("biographieen", biographieen);
  if (linkedin !== null && linkedin !== "") form.append("linkedin", linkedin);
  form.append("rang", rang);

  if (photo !== null) {
    for (let i = 0; i < photo.length; i++) {
      form.append("photo-file", photo[i]);
    }
  } else {
    form.append("photo-file", photo);
  }

  var reponse = null;
  const token = localStorage.getItem("token");

  await axios
    .post(baseUrl + "contacts", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listContact(page = 1, limit = 10) {
  var fullUrl = baseUrl + "contacts?page=" + page;
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function deleteContact(idcontact) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "contacts/" + idcontact, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOneContact(idcontact) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "contacts/" + idcontact, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyContact(
  nom,
  prenom,
  fonction,
  contact,
  biographie,
  photo,
  typecontact,
  biographieen,
  linkedin,
  rang,
  idcontact,
) {
  let form = new FormData();
  form.append("nom", nom);
  form.append("prenom", prenom);
  form.append("fonction", fonction);
  form.append("info", contact);
  form.append("biographie", biographie);
  form.append("biographieen", biographieen);
  form.append("typecontact", typecontact);
  if (linkedin !== null && linkedin !== "") form.append("linkedin", linkedin);
  form.append("rang", rang);

  if (photo !== null) {
    for (let i = 0; i < photo.length; i++) {
      form.append("photo-file", photo[i]);
    }
  } else {
    form.append("photo-file", photo);
  }

  var reponse = null;
  const token = localStorage.getItem("token");

  await axios
    .put(baseUrl + "contacts/" + idcontact, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Type contact
export async function listTypeContact() {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "typecontacts", {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Traduction

// Type et langue sont imposés par l'original côté serveur ; un fichier non fourni est repris de l'original.
export async function traduireActualite(idactualite, valeurs) {
  const token = localStorage.getItem("token");
  const form = new FormData();
  const champs = { titre: valeurs.titre, texte: valeurs.texte, datepublication: valeurs.date, acteur: valeurs.acteur,
    ville: valeurs.ville, theme: valeurs.theme, une: valeurs.une ? "1" : "0", lien: valeurs.lien, mediaSource: valeurs.source };
  Object.entries(champs).forEach(([cle, valeur]) => {
    if (valeur !== null && valeur !== undefined && valeur !== "") form.append(cle, valeur);
  });
  valeurs.keywords.forEach((k) => form.append("keywords", k.idkeyword));
  [["media-file", valeurs.media], ["background-file", valeurs.background], ["document-file", valeurs.document]]
    .forEach(([cle, fichier]) => fichier && form.append(cle, fichier));
  return axios
    .post(baseUrl + "communiques/" + idactualite + "/traduction", form, {
      headers: { Authorization: "Bearer " + token },
    })
    .catch((error) => error.response);
}

export async function lierTraduction(idactualite, idCible) {
  const token = localStorage.getItem("token");
  return axios
    .put(baseUrl + "communiques/" + idactualite + "/traduction/" + idCible, null, {
      headers: { Authorization: "Bearer " + token },
    })
    .catch((error) => error.response);
}

export async function delierTraduction(idactualite) {
  const token = localStorage.getItem("token");
  return axios
    .delete(baseUrl + "communiques/" + idactualite + "/traduction", {
      headers: { Authorization: "Bearer " + token },
    })
    .catch((error) => error.response);
}

// Catégorie média
export async function listCategorieMedia(type = null) {
  var url = baseUrl + "genre/public/";
  if (type !== null && type !== "") url = url + "?typemedia=" + type;

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(url, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });

  return reponse;
}

export async function insertCategorieMedia(description, type = 1) {
  let form = new FormData();
  form.append("description", description);
  if (type !== null && type !== "") {
    form.append("typemedia", type);
  }

  var reponse = null;
  const token = localStorage.getItem("token");

  await axios
    .post(baseUrl + "genre/public/", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });

  return reponse;
}

export async function deleteCategorieMedia(idcategoriemedia) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "genre/public/" + idcategoriemedia, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOneCategorieMedia(idcategoriemedia) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "genre/public/" + idcategoriemedia, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyCategorieMedia(description, idcategoriemedia) {
  let form = new FormData();
  form.append("description", description);

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "genre/public/" + idcategoriemedia, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

// Entité
export async function listAllEntite() {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "entites", { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function insertEntite(description) {
  let form = new FormData();
  form.append("label", description);
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "entites", form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function deleteEntite(identite) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .delete(baseUrl + "entites/" + identite, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getOneEntite(identite) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "entites/" + identite, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function modifyEntite(description, identite) {
  let form = new FormData();
  form.append("label", description);

  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .put(baseUrl + "entites/" + identite, form, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function listSources() {
  var fullUrl = baseUrl + "sources";
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(fullUrl, { headers: { Authorization: "Bearer " + token } })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function importerArticlesCsv(csvFile, mediasUtiles, onProgression = () => {}) {
  const form = new FormData();
  form.append("file", csvFile);
  if (Array.isArray(mediasUtiles)) {
    for (const { fichier, cheminRelatif } of mediasUtiles) {
      const nomEncode = cheminRelatif.replace(/\//g, "--");
      form.append("mediaFiles", fichier, nomEncode);
    }
  }
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "articles-csv", form, {
      headers: { Authorization: "Bearer " + token },
      onUploadProgress: (event) => {
        const total = event.total || event.loaded;
        const pct = total > 0 ? Math.round((event.loaded / total) * 100) : 0;
        onProgression(pct);
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function initialiserImportCsv(csvFile, onProgression = () => {}) {
  const form = new FormData();
  form.append("file", csvFile);
  const token = localStorage.getItem("token");
  var reponse = null;
  await axios
    .post(baseUrl + "articles-csv/init", form, {
      headers: { Authorization: "Bearer " + token },
      onUploadProgress: (event) => {
        const total = event.total || event.loaded;
        const pct = total > 0 ? Math.round((event.loaded / total) * 100) : 0;
        onProgression(pct);
      },
    })
    .then((r) => { reponse = r; })
    .catch((e) => { reponse = e.response; });
  return reponse;
}

export async function envoyerLotMedias(jobId, lot, onProgression = () => {}) {
  const form = new FormData();
  for (const { fichier, cheminRelatif } of lot) {
    const nomEncode = cheminRelatif.replace(/\//g, "--");
    form.append("mediaFiles", fichier, nomEncode);
  }
  const token = localStorage.getItem("token");
  var reponse = null;
  await axios
    .post(baseUrl + `articles-csv/${jobId}/medias`, form, {
      headers: { Authorization: "Bearer " + token },
      onUploadProgress: (event) => {
        const total = event.total || event.loaded;
        const pct = total > 0 ? Math.round((event.loaded / total) * 100) : 0;
        onProgression(pct);
      },
    })
    .then((r) => { reponse = r; })
    .catch((e) => { reponse = e.response; });
  return reponse;
}

export async function lancerImportCsv(jobId) {
  const token = localStorage.getItem("token");
  var reponse = null;
  await axios
    .post(baseUrl + `articles-csv/${jobId}/lancer`, {}, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((r) => { reponse = r; })
    .catch((e) => { reponse = e.response; });
  return reponse;
}

export async function demarrerImportArticlesCsv(csvFile, mediasUtiles, onProgression = () => {}) {
  const form = new FormData();
  form.append("file", csvFile);
  if (Array.isArray(mediasUtiles)) {
    for (const { fichier, cheminRelatif } of mediasUtiles) {
      const nomEncode = cheminRelatif.replace(/\//g, "--");
      form.append("mediaFiles", fichier, nomEncode);
    }
  }
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .post(baseUrl + "articles-csv/start", form, {
      headers: { Authorization: "Bearer " + token },
      onUploadProgress: (event) => {
        const total = event.total || event.loaded;
        const pct = total > 0 ? Math.round((event.loaded / total) * 100) : 0;
        onProgression(pct);
      },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

export async function getStatutImport(jobId) {
  var reponse = null;
  const token = localStorage.getItem("token");
  await axios
    .get(baseUrl + "articles-csv/statut/" + jobId, {
      headers: { Authorization: "Bearer " + token },
    })
    .then(function (response) {
      reponse = response;
    })
    .catch(function (error) {
      reponse = error.response;
    });
  return reponse;
}

